function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import draftToHtml from "draftjs-to-html";
import classnames from "classnames";
import { ALIGN_TYPES } from "constants/align-types";
import { StyledRichTextBlogComponent } from "./rich-text-blog-component.scss";
const DEFAULT_WIDTH_PRECENTAGE = 70;
const DEFAULT_PROPS_BODY_CONTENT = {
    entityMap: {},
    blocks: [
        {
            key: "637gr",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            type: "unstyled",
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {}
        }
    ]
};
class RichTextBlogComponent extends PureComponent {
    render() {
        const { body, width, isMobileOrTabletBrowser, align } = this.props;
        const finalWidth = isMobileOrTabletBrowser ? 100 : width;
        const widthInPercentage = `${finalWidth}%`;
        const htmlBody = this.convertBodyFromWswygJSONToHTML(body);
        return /*#__PURE__*/ _jsx(StyledRichTextBlogComponent, {
            className: classnames("rich-text-blog-component", align),
            style: {
                width: widthInPercentage
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "rich-text-body",
                dangerouslySetInnerHTML: {
                    __html: htmlBody
                }
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "convertBodyFromWswygJSONToHTML", (body)=>{
            return draftToHtml(body);
        });
    }
}
export { RichTextBlogComponent as default };
RichTextBlogComponent.defaultProps = {
    width: DEFAULT_WIDTH_PRECENTAGE,
    body: DEFAULT_PROPS_BODY_CONTENT,
    align: ALIGN_TYPES.CENTER
};
